export default __webpack_public_path__ + "static/media/smart_image.124b05c8.svg";